import { Button, Checkbox, Icon, Image, Popup, Table } from "semantic-ui-react";
import React, { useRef } from "react";
import Thumb, { imageSource } from "../../thumb/components/Thumb";
import { TrackedObjectLink } from "../../object/components/ObjectLink";
import { descriptionByType } from "../../object/rendering";
import { objectType } from "../../page/components/ObjChooser";
import config, { TYPES } from "../../../config";
import StackGrid from "react-stack-grid";

export const SearchResultLayoutControl = ({ layout, setLayout }) => (
  <div style={{ flex: 1, textAlign: "right" }}>
    <Button.Group>
      <Button
        icon
        active={layout === "visual"}
        onClick={() => setLayout("visual")}
      >
        <Icon title="Visual layout" name="grid layout" />
      </Button>
      <Button
        icon
        active={layout === "details"}
        onClick={() => setLayout("details")}
      >
        <Icon title="Detail layout" name="list layout" />
      </Button>
    </Button.Group>
  </div>
);

const VisualSearchResults = ({ results, limit, ...props }) => {
  const grid = useRef(null);
  return (
    <StackGrid columnWidth={150} monitorImagesLoaded gridRef={grid.current}>
      {results
        .slice(0, limit)
        .map(obj =>
          obj ? (
            <Thumb showText showMeta key={obj.ID[0]} obj={obj} {...props} />
          ) : (
            "Error: empty obj in searchresults"
          )
        )}
    </StackGrid>
  );
};

function collectionIdentifier(obj) {
  if (
    obj.hasOwnProperty("NATURALIS_LABEL") ||
    obj.hasOwnProperty("NATURALIS_ID")
  ) {
    return obj["NATURALIS_LABEL"] || obj["NATURALIS_ID"];
  }

  return obj["ID"];
}

function objectFacetName(obj) {
  const t = objectType(obj);
  return config.FACETS[t] || TYPES[t] || t;
}

const DetailSearchResults = ({
  results,
  limit,
  section,
  history,
  checkboxHandler
}) => {
  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell style={{ width: "40px" }} />
          <Table.HeaderCell>ID</Table.HeaderCell>
          <Table.HeaderCell>Description</Table.HeaderCell>
          <Table.HeaderCell>Type</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {results.slice(0, limit).map(obj => (
          <Table.Row key={obj["ID"][0]}>
            <Table.Cell>
              <Checkbox
                // checked={this.props.isChecked}
                onClick={() => checkboxHandler(obj)}
              />
            </Table.Cell>
            <Table.Cell>
              {imageSource(obj) ? (
                <Popup
                  position="top center"
                  trigger={<Icon name="image" style={{ display: "inline" }} />}
                >
                  <Popup.Content>
                    <Image src={imageSource(obj)} size="medium" />
                  </Popup.Content>
                </Popup>
              ) : null}
              <TrackedObjectLink id={obj["ID"][0]} section={section}>
                {collectionIdentifier(obj)}
              </TrackedObjectLink>
            </Table.Cell>
            <Table.Cell style={{ wordBreak: "break-all" }}>
              {descriptionByType(obj)}
            </Table.Cell>
            <Table.Cell>{objectFacetName(obj)}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export const searchResultLayouts = {
  visual: VisualSearchResults,
  details: DetailSearchResults
};

export function createResultLayout(layout) {
  return searchResultLayouts[layout] || VisualSearchResults;
}
